import React, { useMemo } from 'react'
import { MainNavigation as BaseNavigation } from '@domain-group/suit-theme'

import useMainNavigation from '@hooks/useMainNavigation'
import useEntityImpersonation from '@hooks/useEntityImpersonation'

import systemBrandPayload from '@components/systemBrands/default'
import generateMainNavigationItems from '@sections/Client/utils/generateMainNavigationItems'

import useAgencySelector from '@hooks/useAgencySelector'
import useCurrentUser from '@hooks/useCurrentUser'
import useLoginAsUser from '@hooks/useLoginAsUser'
import useFlipperKey from '@hooks/useFlipperKey'

interface MainNavigationProps {
  minimized: boolean,
  nestedNavigation: React.ReactNode,
}

const MainNavigation = (props: MainNavigationProps) => {
  const { minimized, nestedNavigation } = props

  const mainNavigationPayload = useMainNavigation()
  const { callbacks: { toggleNavigation }, showNavigation } = mainNavigationPayload

  const currentUserPayload = useCurrentUser()
  const { currentUser, currentUser: { association_id } } = currentUserPayload

  // @ts-expect-error TS2345
  const entityImpersonationPayload = useEntityImpersonation(currentUser)
  const { callbacks: { unlinkImpersonation } } = entityImpersonationPayload

  const { callbacks: { loginAsUser } } = useLoginAsUser()

  const { hasMultipleAgencies, selectedAgencyId } = useAgencySelector()
  const { isEnabled: intercomEnabled } = useFlipperKey('intercom')

  const navigationItems = useMemo(() => generateMainNavigationItems({
    callbacks: { loginAsUser, unlinkImpersonation },
    currentUserPayload,
    hasMultipleAgencies,
    intercomEnabled,
    // @ts-expect-error TS2322
    selectedAgencyId,
  }), [association_id, hasMultipleAgencies, selectedAgencyId])

  return (
    <BaseNavigation
      // @ts-expect-error TS2322
      callbacks={{ toggleSidebar: toggleNavigation }}
      minimized={minimized}
      // @ts-expect-error TS2322
      navigationItems={navigationItems}
      nestedNavigation={nestedNavigation}
      nestedNavigationWidth={240}
      showNavigation={showNavigation}
      // @ts-expect-error TS2322
      systemBrandPayload={systemBrandPayload}
      width={220}
    />
  )
}

export default MainNavigation
